import { Injectable } from "@angular/core";
import {AppConfigService} from '../services/appConfig.service';

@Injectable()
export class EbetService {
    constructor(private configService: AppConfigService) {}

    ebetLogin(data = {}, nav: any) {
        data["flag"] = 'EbetLoginBean_ebetlogin';
        return this.configService.getEbetLogin(data, nav);
    }

    ebetUserInfor(data = {}, nav: any) {
        data["flag"] = 'EbetGameBean_ebetGetUserInfor';
        return this.configService.getEbetUserInfor(data, nav);
    }

    ebetTransferBalance(data = {}, nav: any) {
        let flag = data["direction"] === 3 ? "EbetGameBean_ebetDeposit" : "EbetGameBean_ebetWithdraw";
        data["flag"] = flag;
        return this.configService.getEbetTransferBalance(data, nav);
    }
}


// WEBPACK FOOTER //
// ./src/services/ebet.service.ts